import React from 'react';
import {compose} from "redux";
import { Popover, withStyles} from "@material-ui/core";
import { SM, XS} from "../../../../constants/constants";
import ChatBox from "../../../chat/ChatBox";

const styles = (theme) => ({
    addChatPopover: {
        borderRadius: 13,

        '& > .MuiPaper-root': {
            borderRadius: 13,
        }
    },
    addChatPopoverContent: {
        borderRadius: 13,
        border: 'none',
        height: 800,
        maxHeight: 'calc(100vh - 60px)',
        width: 800,
        maxWidth: 'calc(100vw - 60px)',
        [theme.breakpoints.between(XS, SM)]: {
            maxWidth: 'calc(100%)',
            height: 'calc(100vh - 150px)',
        },
        '& .headerModalWrapper': {
            display: 'none'
        },
        '& .bodyModalWrapper': {
            padding: 0,
            height: '100%',
            maxHeight: 'unset'
        }
    },
});

class PopoverAddChat extends React.Component{
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const { anchorEl ,onClose, classes, formValuePopover} = this.props;
        return <Popover
            className={classes.addChatPopover}
            open={true}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
        >
            <div
                className={classes.addChatPopoverContent}
            >
                <ChatBox dataRequest={formValuePopover} onClose={onClose}/>
            </div>
        </Popover>;
    }
}

export default compose(withStyles(styles))(PopoverAddChat);
